import { HorizontalFadeMask, LoaderSvg, type VehicleLoaderProps, useSvgId } from "../loader-svg-parts";
import { VehicleOutline } from "../vehicle-outline";

export function VehicleLoaderLane({ className }: VehicleLoaderProps) {
  const trailGradientId = useSvgId("vehicle-loader-lane-trail");
  const maskId = useSvgId("vehicle-loader-lane-mask");

  return (
    <LoaderSvg viewBox="0 24 120 20" modifiers="vehicle-loader-driving" className={className}>
      <defs>
        <linearGradient id={trailGradientId} gradientUnits="userSpaceOnUse" x1={-30} x2={4} y1="0" y2="0">
          <stop offset="0" stopColor="currentColor" stopOpacity="0" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.8" />
        </linearGradient>
      </defs>
      <HorizontalFadeMask id={maskId} x={0} y={24} width={120} height={20} />
      <g mask={`url(#${maskId})`}>
        <line
          x1={2}
          x2={118}
          y1={41}
          y2={41}
          strokeWidth={1.2}
          strokeLinecap="round"
          className="stroke-muted-foreground/25"
        />
        <g className="vehicle-loader-lane-mover text-primary">
          <rect x={-30} y={40.4} width={33} height={1.2} rx={0.6} fill={`url(#${trailGradientId})`} />
          <g transform="translate(0 14) scale(0.5)">
            <VehicleOutline />
          </g>
        </g>
      </g>
    </LoaderSvg>
  );
}
